import EmailNotification from './react-email.vue';

export default EmailNotification;